













import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  @Model('change', { type: String })
  readonly currency: string | null;
  @Prop({ required: false }) readonly label: string;
  @Prop({ required: false }) readonly rules: any;
  @Prop({ required: false, default: false }) readonly hideDetails: boolean;
  @Prop({ required: false, default: false }) readonly dense: boolean;
  @Prop({ default: false, type: Boolean }) readonly readonly: boolean;

  currencyInput: string | null = null;

  get parsedCurrency() {
    if (this.currencyInput !== '') {
      return this.parseCurrency(this.currencyInput);
    } else {
      return null;
    }
  }

  parseCurrency(value: string | null) {
    if (value === null) {
      return null;
    }
    return String(this.$parseCurrency(value));
  }

  formatCurrency(value: string) {
    if (typeof value === 'string' && value !== '') {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
      }).format(Number(value));
    } else {
      return null;
    }
  }

  setValue(value: string) {
    this.currencyInput = this.formatCurrency(value);
  }

  mounted() {
    if (typeof this.currency === 'string' && this.currency !== '') {
      this.currencyInput = this.formatCurrency(this.currency);
    }
  }

  @Watch('currencyInput')
  inputChanged() {
    let currentValue = null;
    if (this.currency) {
      currentValue = this.parseCurrency(this.currency);
    }
    if (this.parsedCurrency !== currentValue) {
      this.$emit('change', this.parsedCurrency);
    }
  }
}
